import { OrganizationPermission, Role } from '@gm-commercial/profile-model';
import { INSIGHTS_IN_CSP_FLAG } from '~/common/models/featureFlags.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';
import ORGANIZATIONS_SHOP_ROUTES from './catalog/constants';
import ORGANIZATIONS_EXPENSES_ROUTES from './expenses/constants';
import ORGANIZATIONS_FLEETS_ROUTES from './fleets/constants';
import ORGANIZATIONS_HOME_ROUTE from './home/constants';
import ORGANIZATIONS_REPORTS_ROUTES from './reports/constants';
import ORGANIZATIONS_USERS_ROUTES from './users/constants';
import ORGANIZATIONS_VEHICLES_ROUTES from './vehicles/constants';
import ORGANIZATIONS_MAP_ROUTES from './vehicles/map/constants';

const OrganizationTermsConditions = lazyWithReload(
  () =>
    import(
      '~/features/organizations/termsConditionsNew/OrganizationTermsConditionsNew'
    )
);
const OrganizationListView = lazyWithReload(
  () => import('~/features/organizations/list/OrganizationListView')
);
const OrganizationDetails = lazyWithReload(
  () => import('~/features/organizations/details/OrganizationDetails')
);
const OrganizationInsightsView = lazyWithReload(() =>
  import('~/routes/organizations/insights/InsightsView').then((module) => ({
    default: module.InsightsView,
  }))
);

const ORGANIZATIONS_ROUTES = {
  ...ORGANIZATIONS_MAP_ROUTES,
  ...ORGANIZATIONS_FLEETS_ROUTES,
  ...ORGANIZATIONS_USERS_ROUTES,
  ...ORGANIZATIONS_VEHICLES_ROUTES,
  ...ORGANIZATIONS_REPORTS_ROUTES,
  ...ORGANIZATIONS_SHOP_ROUTES,
  ...ORGANIZATIONS_EXPENSES_ROUTES,
  [RouteName.ORGANIZATIONS_HOME]: ORGANIZATIONS_HOME_ROUTE,
  [RouteName.ORGANIZATIONS]: {
    name: RouteName.ORGANIZATIONS,
    path: '/organizations',
    authorizedPerms: [OrganizationPermission.READ],
    authorizedRoles: [
      Role.GMF_ADVISOR,
      Role.SYSTEM_MANAGER,
      Role.SYSTEM_READER,
      Role.TECHNICAL_MANAGER,
    ],
    element: OrganizationListView,
  },
  [RouteName.ORGANIZATIONS_DETAILS]: {
    name: RouteName.ORGANIZATIONS_DETAILS,
    path: '/organizations/:organizationsId',
    authorizedPerms: [OrganizationPermission.READ],
    authorizedRoles: [
      Role.GMF_ADVISOR,
      Role.SYSTEM_MANAGER,
      Role.ORG_MANAGER,
      Role.SYSTEM_READER,
      Role.TECHNICAL_MANAGER,
    ],
    element: OrganizationDetails,
  },
  [RouteName.ORGANIZATION_TERMS_AND_CONDITIONS]: {
    name: RouteName.ORGANIZATION_TERMS_AND_CONDITIONS,
    path: '/organizations/:organizationsId/terms-and-conditions',
    authorizedPerms: [],
    element: OrganizationTermsConditions,
  },
  [RouteName.ORGANIZATIONS_INSIGHTS]: {
    name: RouteName.ORGANIZATIONS_INSIGHTS,
    path: '/organizations/:organizationsId/insights',
    authorizedPerms: [OrganizationPermission.READ],
    authorizedRoles: [
      Role.ORG_MANAGER,
      Role.SYSTEM_MANAGER,
      Role.FLEET_MANAGER,
    ],
    element: OrganizationInsightsView,
    requiredFeatureFlags: [INSIGHTS_IN_CSP_FLAG],
  },
};

export { ORGANIZATIONS_ROUTES };
